import React, { useState, useCallback } from "react";
import { graphql, useStaticQuery } from "gatsby";
import classnames from "classnames";
import ArrowDown from "../icons/arrow-down.svg";
import ArrowUp from "../icons/angle-up-solid.svg";
import CircleMinus from "../icons/circle-minus-light.svg";
import CirclePlus from "../icons/circle-plus-light.svg";

const AgecRow = ({ item, labelManagerLabels }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded((val) => !val);
  return (
    <div className="agec-regulation__row">
      <div className="row">
        {item?.fieldName && (
          <div
            className="col-12 col-md-6 agec-regulation__table-line"
            dangerouslySetInnerHTML={{
              __html: item?.fieldName,
            }}
          ></div>
        )}
        <div
          className={classnames(
            "col-12 col-md-6 agec-regulation__table-line agec-regulation__table-line-desc",
            {
              "agec-regulation__table-line--expandable": !!item.fieldMultiValue?.length,
            }
          )}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: item.fieldMultiValue?.length
                ? item.fieldMultiValue.join(", ")
                : item.fieldBoolean && item.fieldValue === "1"
                ? labelManagerLabels.yes
                : item.fieldBoolean && item.fieldValue === "0"
                ? labelManagerLabels.no
                : item.fieldValue === "-"
                ? ""
                : item.fieldValue === "0"
                ? ""
                : item.fieldValue || "",
            }}
            className={classnames({
              "agec-regulation__table-line_expandable": !!item.fieldMultiValue?.length,
              "open": expanded,
            })}
          />
          {!!item.fieldMultiValue?.length && (
            <button onClick={toggleExpanded} className="d-inline-flex" aria-label="open Button">
              {expanded ? <CircleMinus /> : <CirclePlus />}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const AgecRegulation = ({ data, labelManagerLabels, babelProdotto }) => {
  const { agecRegulation } = useStaticQuery(graphql`
    {
      agecRegulation: liferayAgecRegulation {
        title
        brandLabel
      }
    }
  `);

  const [openTabAccordion, setOpenTabAccordion] = useState(false);

  const toggle = useCallback(() => setOpenTabAccordion((value) => !value), []);

  return (
    <section className="section">
      <div className="container-fluid py-2">
        <div className="agec-regulation__wrapper">
          <div className="row">
            <div className="col-12">
              <div className="agec-regulation">
                <div className={`agec-regulation__box${openTabAccordion ? " open" : ""}`}>
                  {agecRegulation?.title && (
                    <h4 className="agec-regulation__title d-block">
                      <button className="agec-regulation__opener" onClick={toggle}>
                        <div
                          className="agec-regulation__opener"
                          dangerouslySetInnerHTML={{
                            __html: agecRegulation.title,
                          }}
                        ></div>
                        <div className="agec-regulation__arrow-wrapper">
                          <ArrowDown className="down" />
                          <ArrowUp className="up" />
                        </div>
                      </button>
                    </h4>
                  )}
                  <div className="col-12 d-flex pl-4 agec-regulation__line">
                    <div
                      className={`agec-regulation__content${
                        openTabAccordion ? " d-flex flex-column" : " d-none"
                      }`}
                    >
                      {agecRegulation?.brandLabel && babelProdotto?.brandName && (
                        <div className="agec-regulation__row">
                          <div className="row">
                            <div className="col-12 col-md-6 agec-regulation__table-line">
                              {agecRegulation.brandLabel}
                            </div>
                            <div className="col-12 col-md-6 agec-regulation__table-line agec-regulation__table-line-desc">
                              {babelProdotto.brandName}
                            </div>
                          </div>
                        </div>
                      )}
                      {babelProdotto.productName && babelProdotto.productNameField && (
                        <div className="agec-regulation__row">
                          <div className="row">
                            <div className="col-12 col-md-6 agec-regulation__table-line">
                              {babelProdotto.productNameField}
                            </div>
                            <div className="col-12 col-md-6 agec-regulation__table-line agec-regulation__table-line-desc">
                              {babelProdotto.productName}
                            </div>
                          </div>
                        </div>
                      )}
                      {babelProdotto.eanCode && babelProdotto.eanCodeField && (
                        <div className="agec-regulation__row">
                          <div className="row">
                            <div className="col-12 col-md-6 agec-regulation__table-line">
                              {babelProdotto.eanCodeField}
                            </div>
                            <div className="col-12 col-md-6 agec-regulation__table-line agec-regulation__table-line-desc">
                              {babelProdotto.eanCode}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {data?.length &&
                    data.map((item, i) => (
                      <div className="col-12 d-flex pl-4 agec-regulation__line " key={i}>
                        <div
                          className={classnames(
                            "agec-regulation__content",
                            openTabAccordion ? " d-flex flex-column" : " d-none",
                            i === 0 && "mt-0"
                          )}
                        >
                          {item?.title && (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.title,
                              }}
                            ></div>
                          )}
                          {item.data?.map((child, j) => (
                            <AgecRow item={child} labelManagerLabels={labelManagerLabels} key={j} />
                          ))}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgecRegulation;
